/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateNewTask/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreateNewTask({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/CreateNewTask"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let requirementIsSkippableValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'is_skippable',
})
let globalFeatureFlagsIsNewTasksEnabledValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_new_tasks_enabled',
})
let aggregateData = fromAggregate.and(requirementIsSkippableValueData, globalFeatureFlagsIsNewTasksEnabledValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}